import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVectorAnchorPointStraight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vector-anchor-point-straight, no-smoothing"><circle cx="12" cy="7.75" r="3" stroke="currentColor" strokeWidth="1.5"/><path d="M2.75 17.5L10.0526 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M21.25 17.5L14 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVectorAnchorPointStraight;
